import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  BaseMediaListResponse, BaseMediaResponse, BasePornActressListResponse, BasePornActressResponse,
  BasePornCategoryListResponse, BasePornTagListResponse,
  BaseResponse,
  PornService, PornViewData,
} from '@api/backend';
import { HttpClient } from '@angular/common/http';
import { PornRepository } from '@core/repositories/porn.repository';

@Injectable()
export class PornWebRepository extends PornRepository {

  constructor(
    private service: PornService,
    private httpClient: HttpClient,
  ) { super(); }

  public getCategories(): Observable<BasePornCategoryListResponse> {
    try {
      return this.service.getPornCategoriesPornCategoriesGet() ;
    } catch {
      throw new Error('Can\'t execute getCategories api2 method');
    }
  }

  public getTags(): Observable<BasePornTagListResponse> {
    try {
      return this.service.getPornTagsPornTagsGet() ;
    } catch {
      throw new Error('Can\'t execute getCategories api2 method');
    }
  }

  public getList(params: {
    t?: string, c?: string, r?: string, a?: string, q?: string, p?: number,
  }): Observable<BaseMediaListResponse> {
    const { t, c, r, a, q, p } = params;
    try {
      return this.service.getPornPornGet(t, c, r, a, q, p);
    } catch {
      throw new Error('Can\'t execute getList api2 method');
    }
  }

  public getById(media_id: string): Observable<BaseMediaResponse> {
    try {
      return this.service.getMediaPornMediaIdGet(media_id);
    } catch {
      throw new Error('Can\'t execute getById api2 method');
    }
  }

  public like(media_id: string): Observable<BaseResponse> {
    try {
      return this.service.postMediaLikePornMediaIdLikePost(media_id);
    } catch {
      throw new Error('Can\'t execute like api2 method');
    }
  }

  public unlike(media_id: string): Observable<BaseResponse> {
    try {
      return this.service.postMediaUnlikePornMediaIdUnlikePost(media_id);
    } catch {
      throw new Error('Can\'t execute unlike api2 method');
    }
  }

  public share(media_id: string): Observable<BaseResponse> {
    try {
      return this.service.postMediaSharePornMediaIdSharePost(media_id);
    } catch {
      throw new Error('Can\'t execute share api2 method');
    }
  }

  public view(mediaId: string, view: PornViewData): Observable<BaseResponse> {
    try {
      return this.service.postPornViewPornMediaIdViewPost(mediaId, view);
    } catch {
      throw new Error('Can\'t execute view api2 method');
    }
  }

  public getStars(params: {
    piercing?: boolean,
    tattoo?: boolean,
    silicone?: boolean,
    assSize?: string,
    waistSize?: string,
    breastSize?: string,
    height?: string,
    weight?: string,
    age?: string,
    q?: string,
    r?: string,
    p?: number,
    pageSize?: number,
  }): Observable<BasePornActressListResponse> {
    const {
      piercing, tattoo, silicone, assSize, waistSize, breastSize, height, weight, age, q, r, p, pageSize,
    } = params;
    try {
      return this.service.getPornActressesPornActressesGet(
        piercing, tattoo, silicone, assSize, waistSize, breastSize, height, weight, age, q, r, p, pageSize,
      );
    } catch {
      throw new Error('Can\'t execute getStars api2 method');
    }
  }

  public getStarById(id: string):  Observable<BasePornActressResponse> {
    return this.service.getPornActressByNameOrIdPornActressNameOrIdGet(id);
  }

}
